import { EToastType, showToast } from "@/hooks/ui/useToast";
import { getErrorReasonMessage } from "@/locales/errorMessages";

export const showPermissionDeniedToast = () =>
  showToast({
    id: "permission-denied",
    type: EToastType.ERROR,
    message: getErrorReasonMessage("ERR_AUTH_PERMISSION_DENIED") ?? "",
    // Keep the visible toast on repeat clicks; the fixed id blocks duplicates
    stack: true
  });

/**
 * Wraps an action so it runs only when granted; otherwise shows the permission-denied toast.
 */
export const guardPermission =
  <Args extends unknown[]>(
    isGranted: boolean,
    action: (...args: Args) => void
  ) =>
  (...args: Args) => {
    if (!isGranted) {
      showPermissionDeniedToast();
      return;
    }
    action(...args);
  };
